import * as React from "react";
import { useQuery, useMutation } from "@grandvisionhq/graphql";
import { toBillingAddress } from "../../../mappers/Profile/mappers/profile.js";
import UPDATE_BILLING_ADDRESS from "../../../operations/mutations/Profile/operations/mutations/update-billing-address.js";
import GET_BILLING_ADDRESS from "../../../operations/queries/Profile/operations/queries/get-billing-address.js";
const useBillingAddress = ({ onError, onCompleted } = {}) => {
  const setOptions = React.useCallback(
    (reason) => ({
      onError: (error) => {
        onError?.({ reason, error });
      },
      onCompleted: (data) => {
        onCompleted?.({ reason, data });
      },
      // Currently the BE response does not resolve fast enough so we have to temporarily
      // increase the timeout that is configured globally in graphql/src/apollo/client.ts.
      // When the backend performance has been improved, we will remove this and revert
      // to the global config of 10s.
      context: {
        timeout: 2e4
      }
    }),
    [onCompleted, onError]
  );
  const queryOptions = React.useMemo(() => setOptions("QUERY"), [setOptions]);
  const query = useQuery(GET_BILLING_ADDRESS, queryOptions);
  const mutationOptions = React.useMemo(() => setOptions("MUTATION"), [setOptions]);
  const [mutationCallback, mutation] = useMutation(UPDATE_BILLING_ADDRESS, {
    ...mutationOptions,
    refetchQueries: [{ query: GET_BILLING_ADDRESS }]
  });
  return React.useMemo(
    () => ({
      billingAddressData: toBillingAddress(query.data?.me?.defaultBillingAddress),
      updateBillingAddress: async (billingAddress, userId) => {
        await mutationCallback({
          variables: {
            customerId: userId,
            input: billingAddress
          }
        });
      },
      isFetching: query.loading,
      fetchError: query.error,
      isUpdating: mutation.loading
    }),
    [
      mutation.loading,
      mutationCallback,
      query.data?.me?.defaultBillingAddress,
      query.error,
      query.loading
    ]
  );
};
export {
  useBillingAddress
};
//# sourceMappingURL=use-billing-address.js.map
